import React from 'react'
import Box from '@mui/material/Box'
import CheckIcon from 'components/material-symbol/icons/Check'
import {
  SEGMENTED_BUTTON_CHECK_GAP,
  SEGMENTED_BUTTON_CHECK_SIZE,
} from 'lib/segmented-button-styles'

export function SegmentedToggleButtonContent({
  isSelected,
  showCheck = true,
  children,
}) {
  if (!showCheck) {
    return (
      <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
        {children}
      </Box>
    )
  }

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      component="span"
      width="100%"
      sx={{
        whiteSpace: 'nowrap',
        columnGap: isSelected ? `${SEGMENTED_BUTTON_CHECK_GAP}px` : 0,
      }}
    >
      {isSelected ? (
        <CheckIcon
          sx={{
            color: 'currentColor',
            fontSize: SEGMENTED_BUTTON_CHECK_SIZE,
            flexShrink: 0,
          }}
        />
      ) : null}
      <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
        {children}
      </Box>
    </Box>
  )
}
